<template>
<form class="ui large form" @submit.prevent="save" :class="{'loading': form.waiting, 'warning': form.hasErrors()}">
  <app-message :msg="form.appMessage"></app-message>
  <div v-if="saved" class="ui positive message">
    <div>保存しました</div>
  </div>

  <div v-if="!filledAll" class="ui negative message">
    お店とチャットを開始するには電話番号とお名前が必須となります。
  </div>

  <div class="fields">
    <div class="six wide field required">
      <label>メールアドレス</label>
      <input v-model="form.model.login_id" type="text">
      <validation-message :form="form" :field="'login_id'"></validation-message>
    </div>
  </div>
  <div class="fields">
    <div class="six wide field required">
      <label>電話番号</label>
      <input v-model="form.model.tel" type="tel" :placeholder="'080XXXXXXXX'">
      <validation-message :form="form" :field="'tel'"></validation-message>
    </div>
  </div>
  <div class="fields">
    <div class="six wide required field">
      <label>お名前(カナ)</label>
      <input v-model="form.model.name_kana" type="text" :placeholder="'お名前(カナ)'">
      <validation-message :form="form" :field="'name_kana'"></validation-message>
    </div>
  </div>
  <button type="submit" class="ui submit button orange" :class="{'loading': form.waiting}">保存する</button>
 </div>
</form>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(),
            saved: false,
            filledAll: true
        };
    },
    created: function() {
        this.form.get('/api/member/profile', function(response) {
            this.form.model = response.data;
            this.form.model.login_id = response.data.user.login_id;
            if (!this.form.model.tel || !this.form.model.name_kana) {
                this.filledAll = false;
            }
        });
    },
    methods: {
        save: function() {
            this.userRole === '' && this.form.put('/api/member/profile', function(response) {
                this.form.model = response.data;
                this.form.model.login_id = response.data.user.login_id;
                this.saved = true;

                if (this.query().redirect) {
                    location.href = this.query().redirect;
                } else {
                    setTimeout(function() {
                        location.reload();
                    }, 500);
                }
            });
        }
    }
};
</script>
